import { pageRoutes } from 'constants/routing'
import { withMarketingParams } from 'lib/marketingParams'
import { Dropdown } from 'react-bootstrap'
import 'lib/reactBootstrapReact19/dropdown'
import NavDropdown from '../components/NavDropdown'
import styles from '../index.module.scss'
import LoginNavItemsWrapper from '../components/LoginNavItemsWrapper'
import logEvent from 'utils/logEvent'
import { RudderEvent } from 'constants/rudderEvents'
import useBreakpoint from 'hooks/useBreakPoint'
import { dashboardHeaderLinkText } from 'constants/dashboard'
import { useContext } from 'react'
import UserContext from 'context/common/User/UserContext'
import {
  B2bPartnerChannelType,
  B2bPartnershipType,
} from 'common/B2BVerification/constants'

/*
  TODO: Remove the code related to isBllingTabVisible later
  as a part of feature flag cleanup task after the Billing 
  tab ticket has been merged to prod.
*/

const UserLoggedInNavItems: React.FC = () => {
  const { user, isActiveB2BUser } = useContext(UserContext)
  const { channelType, dealStructure } = user?.businessPartner ?? {}
  const isGoldOrSilverPartnerClient =
    isActiveB2BUser &&
    channelType !== B2bPartnerChannelType.MARKETING_PARTNER &&
    dealStructure !== B2bPartnershipType.NONE
  const { isMobileScreen } = useBreakpoint()

  const onFireSideClick = () => {
    logEvent(RudderEvent.OPENED_FIRESIDE, { source: 'hamburger_menu' })
  }

  return (
    <div className="d-flex align-items-center">
      <NavDropdown navDropdownClass="py-2 pr-3">
        {({ resetToggle }) => (
          <LoginNavItemsWrapper
            loginNavItemHelpers={{
              resetToggle,
            }}
          >
            <div className="px-4 pt-3">
              {isMobileScreen && (
                <>
                  <Dropdown.Item
                    className={styles.dropdown_item}
                    href={withMarketingParams(pageRoutes.DASHBOARD_USER_HOME)}
                    onClick={resetToggle}
                  >
                    {dashboardHeaderLinkText.DASHBOARD}
                  </Dropdown.Item>

                  <Dropdown.Item
                    className={styles.dropdown_item}
                    href={withMarketingParams(
                      pageRoutes.DASHBOARD_USER_SESSIONS_UPCOMING
                    )}
                    onClick={resetToggle}
                  >
                    {dashboardHeaderLinkText.SESSIONS}
                  </Dropdown.Item>

                  {!isGoldOrSilverPartnerClient && (
                    <Dropdown.Item
                      className={styles.dropdown_item}
                      href={withMarketingParams(
                        pageRoutes.DASHBOARD_USER_BILLING
                      )}
                      onClick={resetToggle}
                    >
                      {dashboardHeaderLinkText.BILLING}
                    </Dropdown.Item>
                  )}

                  <Dropdown.Item
                    className={styles.dropdown_item}
                    href={withMarketingParams(
                      pageRoutes.DASHBOARD_USER_FIRESIDE
                    )}
                    onClick={() => {
                      resetToggle()
                      onFireSideClick()
                    }}
                  >
                    {dashboardHeaderLinkText.FIRESIDE_COURSES}
                  </Dropdown.Item>
                </>
              )}

              <Dropdown.Item
                className={styles.dropdown_item}
                href={withMarketingParams(
                  pageRoutes.DASHBOARD_USER_ACCOUNT_PATIENT_DETAILS
                )}
                onClick={resetToggle}
              >
                {dashboardHeaderLinkText.ACCOUNT}
              </Dropdown.Item>
            </div>
          </LoginNavItemsWrapper>
        )}
      </NavDropdown>
    </div>
  )
}

export default UserLoggedInNavItems
